import {
  Aldeia,
  CidadaoTerritorioBasico,
  CondicoesMoradia,
  Dsei,
  ImovelUltimasVisitasQuery,
  ImovelVisitaQuery,
  Maybe,
  PoloBase,
  Prontuario,
  TipoEnderecoEnum,
  TipoImovelEnum,
} from 'graphql/types.generated'

export type UltimasVisitasQueryResult = ImovelUltimasVisitasQuery['visitas']['content']
export type UltimasVisitasQueryResultRow = UltimasVisitasQueryResult[0]
export type ImovelVisitaResult = ImovelVisitaQuery['visita']

export const TipoOrigemRecord: Record<string, string> = {
  'Não informado': 'Não informado',
  OFFLINE: 'CDS Offline',
  ONLINE: 'CDS',
  PEC: 'PEC',
  EXTERNO: 'RAS PEC',
  ANDROID_ACS: 'e-SUS Território',
}

export interface ImovelUrlParams {
  imovelId: string
  cidadaoId: string
  redirect: string
  endereco: string
}

export interface ImovelHeaderDto {
  tipoImovel: TipoImovelEnum
  bairro: string
  cep: string
  logradouro: string
  nomeTipoLogradouro: string | null
  nomeMunicipio: string
  siglaUfMunicipio: string
  complemento: string
  numero: string
  telefoneContato: string
  telefoneResidencial: string
  condicoesMoradia: CondicoesMoradia
  microarea: string
  latitude: number
  longitude: number
  tipoEndereco: TipoEnderecoEnum
  numeroResidenciaIndigena: string
  aldeia: Aldeia
  poloBase: PoloBase
  dsei: Dsei
}

export type CidadaoTerritorioBasicoWithProntuarioId = Omit<CidadaoTerritorioBasico, 'prontuario'> & {
  prontuario?: Maybe<Pick<Prontuario, 'id'>>
}
